const KEY_ACCEPT_PRIVACY = 'acceptPrivacy';
const KEY_ACCEPT_EU = 'acceptEu';
const KEY_LAST_IP_CHECK = 'last_ip_check';
const KEY_IS_TRUE = '1';
// const KEY_IS_FALSE = '0';

const $body = document.body;
const $privacyBarStan = document.querySelector('.js-privacy-bar--standard');
const $privacyCloseStan = document.querySelector('.js-privacy-bar-close--standard');
const $privacyBarEu = document.querySelector('.js-privacy-bar--eu');
const $privacyBarEuOverlay = document.querySelector('.privacy-bar--eu-overlay');
const $privacyCloseEu = document.querySelector('.js-privacy-bar-close--eu');

function insertGtm() {
  const gtmCode = `
    <!-- Google Tag Manager -->
    <script>
    (function(w,d,s,l,i){
      w[l]=w[l]||[];
      w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});
      var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),
          dl=l!='dataLayer'?'&l='+l:'';
      j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
      f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','GTM-THD5X3X');
    </script>
    <!-- End Google Tag Manager -->
  `;

  $body.insertAdjacentHTML('beforeend', gtmCode);
}

function handleResize() {
  if ($body.classList.contains('show-privacy-bar')) {
    const barHeight = document.querySelector('.js-privacy-bar').offsetHeight;
    $body.style.paddingBottom = `${barHeight}px`;
  }
}

function removePadding() {
  $body.classList.remove('show-privacy-bar');
  $body.style.paddingBottom = '0';
}

function sendIpToLog() {
  const dataFromButton = $privacyCloseEu.dataset;
  const bodyData = new URLSearchParams({ action: 'Ip2Country/acceptgdpr' });

  bodyData.append(dataFromButton.csrfName, dataFromButton.csrfValue);

  fetch('', {
    method: 'POST',
    body: bodyData,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  })
    .then((response) => response.json())
    .then((data) => console.log('success', data))
    .catch((error) => console.error('error', error));
}

function close() {
  $privacyBarStan.classList.add('hide');
  localStorage.setItem(KEY_ACCEPT_PRIVACY, KEY_IS_TRUE);
  localStorage.setItem(KEY_LAST_IP_CHECK, Date.now());
  removePadding();
}

function closeEu() {
  $privacyBarEu.classList.add('hide');
  $privacyBarEuOverlay.classList.add('hide');
  localStorage.setItem(KEY_ACCEPT_EU, KEY_IS_TRUE);
  localStorage.setItem(KEY_LAST_IP_CHECK, Date.now());
  sendIpToLog();
  removePadding();

  if (window.craftEnvProd) {
    insertGtm();
  }
}

function showEu() {
  // remove style display:none
  $privacyBarEuOverlay.style.removeProperty('display');
  $privacyBarEu.style.removeProperty('display');

  $privacyCloseEu.addEventListener('click', closeEu);
  $body.classList.add('show-privacy-bar');
  window.addEventListener('resize', handleResize);
  window.dispatchEvent(new Event('resize'));
}

function showPrivacy() {
  // remove style display:none
  $privacyBarStan.style.removeProperty('display');
  $privacyCloseStan.addEventListener('click', close);
  $body.classList.add('show-privacy-bar');
  window.addEventListener('resize', handleResize);
  window.dispatchEvent(new Event('resize'));

  if (window.craftEnvProd) {
    insertGtm();
  }
}

function init() {
  const now = Date.now();
  const ONE_HOUR = 60 * 60 * 1000;
  const acceptPrivacy = localStorage.getItem(KEY_ACCEPT_PRIVACY);
  const acceptEu = localStorage.getItem(KEY_ACCEPT_EU);
  const lastIpCheck = localStorage.getItem(KEY_LAST_IP_CHECK);

  if (
    acceptEu === KEY_IS_TRUE
    || (acceptPrivacy === KEY_IS_TRUE && lastIpCheck !== null && now - lastIpCheck < ONE_HOUR)
  ) {
    insertGtm();
  } else {
    const bodyData = new URLSearchParams({ action: 'Ip2Country/isgdpr' });
    fetch('', {
      method: 'POST',
      body: bodyData,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.result) {
          showEu();
          localStorage.setItem(KEY_LAST_IP_CHECK, now);
        } else {
          showPrivacy();
          localStorage.setItem(KEY_LAST_IP_CHECK, now);
        }
      })
      .catch((error) => console.error('error', error));
  }
}

export default {
  init() {
    init();
  },
};
